import {
  SET_APPOINTMENT_DATA,
  SET_FILTERS_DATA,
  CLEAR_FILTERS_DATA,
  PREVIOUS_PATH,
  SET_PAGINATION_CONFIG,
  CLEAR_PAGINATION_CONFIG,
  FORM_FILTERS,
  FORM_FILTERS_CLEAR,
} from '../types';

// Appoitment data
export function setAppointmentData(data) {
  return (dispatch) => {
    dispatch(setAppointmentDataDS(data));
  };
}

// Set filters data
export const setFiltersData = (data) => {
  return (dispatch) => {
    dispatch(setFiltersDataDS(data));
  };
};

// Clear filters
export const clearFiltersData = () => {
  return (dispatch) => {
    dispatch(clearFiltersDataDS());
  };
};

// Actios to know if filters should be cleaned
export const setPreviousPath = (path) => {
  return (dispatch) => {
    dispatch(setPreviousPathDS(path));
  };
};

// Set pagination config
export const setPaginationConfig = (data) => {
  return (dispatch) => {
    dispatch(setPaginationConfigDS(data));
  };
};

// Clear pagination config
export const clearPaginationConfig = () => {
  return (dispatch) => {
    dispatch(clearPaginationConfigDS());
  };
};

export const setFormFilters = (form) => {
  return (dispatch) => {
    dispatch(setFormFiltersDS(form));
  };
};

export const clearFormFilters = () => {
  return (dispatch) => {
    dispatch(clearFormFiltersDS({}));
  };
};

// Appoitment data
const setAppointmentDataDS = (data) => ({
  type: SET_APPOINTMENT_DATA,
  payload: data,
});

const setFiltersDataDS = (data) => ({
  type: SET_FILTERS_DATA,
  payload: data,
});

const clearFiltersDataDS = () => ({
  type: CLEAR_FILTERS_DATA,
});

const setPreviousPathDS = (path) => ({
  type: PREVIOUS_PATH,
  payload: path,
});

const setPaginationConfigDS = (data) => ({
  type: SET_PAGINATION_CONFIG,
  payload: data,
});

const clearPaginationConfigDS = () => ({
  type: CLEAR_PAGINATION_CONFIG,
});

const setFormFiltersDS = (form) => ({
  type: FORM_FILTERS,
  payload: form,
});

const clearFormFiltersDS = () => ({
  type: FORM_FILTERS_CLEAR,
});
